import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Row, Col, Button, Badge } from 'antd';
import util from '../../util';
import CsTop from '../public/cs-top';
import EditorMd from './EditorMd';

const { getRandom } = util;
@inject('ecodeStore')
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'ecode-form',
  }

  onChangeMd = (val) => {
    const { ecodeStore: { setMobxState, readme } } = this.props;
    if (val !== readme) {
      setMobxState({ readme: val, isEdit: true });
    } else {
      setMobxState({ isEdit: false });
    }
  }

  renderFormItem = () => {
    const { prefixCls, renderFields, onSubmit, ...restProps } = this.props;
    let { ecodeStore: { fieldList, detailColSpan } } = this.props;
    const renderField = fieldList.map((field) => {
      const colSpan = detailColSpan === 1 ? 12 : 24 / detailColSpan;
      const offset = detailColSpan === 1 ? 6 : 0;
      return (
        <Col 
          span={field.conditionType === 'markdown' ? 24 : colSpan}
          offset={offset} key={field.domkey} 
          className={`${field.domkey === 'title' && `${prefixCls}-form-hidden`}`}
        >
          {
            field.conditionType === 'markdown' ? [
              <div key="ecode-enableMd-EditorMd-info" className="ecode-enableMd-EditorMd-info">图片上传请通过快捷键（ctrl+v/command+v）方式上传</div>,
              <EditorMd {...restProps} key="ecode-enableMd-EditorMd" onChange={this.onChangeMd} onSave={() => typeof onSubmit === 'function' && onSubmit(false)} />
            ] : (
              <Row className={`${prefixCls}-form`}>
                <Col span={6} className={`${prefixCls}-form-label`}><span>{field.label}：</span></Col>
                <Col span={18} className={`${prefixCls}-form-wrapper`}>
                  <Form.Item className={`${prefixCls}-form-${field.viewAttr}`}>
                    { typeof renderFields === 'function' && renderFields(field) }
                  </Form.Item>
                </Col>
              </Row>
            )
          }
        </Col>
      )
    });
    return (<Row className={`${prefixCls}-con ecode-title-con`}>
      {renderField}
    </Row>);
  }

  onSubmit = () => {
    const { onSubmit } = this.props;
    if (typeof onSubmit === 'function') onSubmit();
  }

  render() {
    const { prefixCls, form, ecodeStore: { isEdit } } = this.props;
    const buttons = [
      
    ];
    return (
      <div className={`${prefixCls}`}>
        <CsTop prefixCls="ecode-form-top ecode-title-form-title" title={<Badge dot={isEdit}>{`标题：${form.getFieldValue('title') || ''}`}</Badge>}>
          {this.renderFormItem()}
        </CsTop>
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/ecodeLocal/TopForm.js